import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";
import { MaterialModule } from "../../material-module";

@Component({
    selector: "app-footer",
    standalone: true,
    imports: [CommonModule, RouterModule, MaterialModule],
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
})
export class FooterComponent {}
